export default "__VITE_ASSET__3f8d8ba2__"